import Skeleton from 'components/Skeleton/Skeleton';

import { HorizontalContainer } from '@picsart/design-system/components/HorizontalContainer';
import { useColorScheme } from 'redesignedComponents/context/colorScheme';
import classnames from 'classnames';
import useStyles from './styles';
import type { RatingProps } from './types';

const RatingFallback = ({ title, buttonProps, description }: RatingProps) => {
  const colorScheme = useColorScheme();
  const styles = useStyles({ colorScheme });

  return (
    <div data-testid="skeleton" className={styles.root}>
      <HorizontalContainer className={styles.container}>
        {title?.trim() && <Skeleton className={styles.skeletonTitle} />}
        <Skeleton className={classnames(styles.skeletonRating, styles.starsReviews)} />
        {description && <Skeleton className={styles.skeletonDescription} />}
        {buttonProps && <Skeleton className={styles.skeletonButton} />}
      </HorizontalContainer>
    </div>
  );
};

export default RatingFallback;
